import { createSelector } from 'reselect';

import { PRODUCT_DISLIKE, PRODUCT_LIKE, PRODUCT_NEUTRAL } from '../constants';
import { dataServiceReducerKey } from '../reducers';
import { userFavoritesReducerKey } from './reducer';

/**
* @param {Object} state
* @return {Object} All productLikeStatuses
*/
const emptyObject = {};
export const getAllLikeStatuses = (state) =>
  state[dataServiceReducerKey][userFavoritesReducerKey].productLikeStatuses || emptyObject;

/**
* Gets favorite product like status [-1 or 1 or 0]
* @param {Object} state
* @param {Number} productId
* @return {Number} likeStatus specific to one productId
*/
export const getProductLikeStatus = ({ state, productId }) =>
  getAllLikeStatuses(state)[productId] || PRODUCT_NEUTRAL;

/**
* @param {Object} state
* @param {Number} productId
* @return {Boolean} true if product is liked, false otherwise
*/
export const getIsProductLiked = ({ state, productId }) =>
  getProductLikeStatus({ state, productId }) === PRODUCT_LIKE;

/**
* @param {Object} state
* @param {Number} productId
* @return {Number} true if product is disliked, false otherwise
*/
export const getIsProductDisliked = ({ state, productId }) =>
  getProductLikeStatus({ state, productId }) === PRODUCT_DISLIKE;

/**
* @param {Object} state
* @return {Object} All productDislikeReasons
*/
export const getAllDislikeReasons = (state) =>
  state[dataServiceReducerKey][userFavoritesReducerKey].productDislikeReasons || emptyObject;

/**
* @param {Object} state
* @param {Number} productId
* @return {Array} dislikeReasons specific to one productId
*/
export const getProductDislikeReasons = createSelector(
  (state) => getAllDislikeReasons(state),
  (productId) => productId,
  (dislikeReasons, productId) => dislikeReasons[productId] || null
);

/**
* @param {Object} state
* @return {Array} likedProductsIds [all liked productIds]
*/
export const getAllLikedProductIds = createSelector(
  (state) => getAllLikeStatuses(state),
  (likeStatuses) => {
    let likedProductsIds = [];

    Object.keys(likeStatuses).forEach(productId => {
      if (likeStatuses[productId] === PRODUCT_LIKE) {
        likedProductsIds.push(Number(productId));
      }
    });

    return likedProductsIds;
  }
);
